import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SplitOnDirective } from './split-on.directive';

@NgModule({
  declarations: [SplitOnDirective],
  imports: [CommonModule],
  exports: [SplitOnDirective],
})
export class FeatureFlagsModule {}
